/**
 * 9d: сообщения для UI после попытки учесть hold в смене.
 *
 * Вынесено из PosPage, чтобы `releaseHold=false` можно было проверить
 * unit-тестом без браузера и без гонки с IndexedDB.
 */
export interface HoldAccountingNotice {
  kind: 'info' | 'error'
  text: string
}

export function holdPrintNotice(accounted: boolean): HoldAccountingNotice {
  return accounted
    ? { kind: 'info', text: 'Hold-чек пробит фискально' }
    : {
        kind: 'error',
        text: 'Чек пробит, но счётчики смены не обновлены. Смена заблокирована; перезапустите кассу для recovery.'
      }
}

export function holdCancelNotice(accounted: boolean): HoldAccountingNotice {
  return accounted
    ? { kind: 'info', text: 'Hold-чек отменён, наличные возвращены' }
    : {
        kind: 'error',
        text: 'Hold-чек отменён, но счётчики смены не обновлены. Не закрывайте смену; перезапустите кассу для recovery.'
      }
}
